<template>
  <div>
    <el-button
      ref="benchButton"
      :class="['bench-btn', typeClass]"
      :style="{ width: bWidth, backgroundColor: customBgColor, borderColor: customBdColor }"
      :disabled="disabled"
      type="primary"
      @click="clickFn"
      @mouseenter.native="enter(true)"
      @mouseleave.native="enter(false)"
    >
      <slot></slot>
      {{ label }}
    </el-button>
  </div>
</template>
<script>
export default {
  name: 'BenchButton',
  props: {
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '120px'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '' // #5a62b3,#40489c  默认颜色，hover颜色
    }
  },
  data() {
    return {
      customBgColor: '',
      customBdColor: ''
    };
  },
  computed: {
    bWidth() {
      let wid = '';
      if (this.size.indexOf('px') == -1) {
        wid = this.size + 'px';
      } else {
        wid = this.size;
      }
      return wid;
    },
    typeClass() {
      let classname = '';
      switch (this.type) {
        case 'danger':
          classname = 'btn-danger';
          break;
        case 'plain':
          classname = 'btn-plain';
          break;
        case 'pink':
          classname = 'btn-pink';
          break;
      }
      return classname;
    }
  },
  mounted() {
    const colors = this.color.split(',');
    if (this.color) {
      this.customBgColor = this.type == 'plain' ? '#fff' : colors[0];
      this.customBdColor = colors[0];
    }
  },
  methods: {
    clickFn() {
      this.$emit('click');
    },
    /**
     * 自定义按钮颜色
     */
    enter(isHover) {
      const colors = this.color.split(',');
      if (this.color) {
        if (isHover) {
          this.customBgColor = this.type == 'plain' ? '#fff' : colors[1];
          this.customBdColor = colors[1];
        } else {
          this.customBgColor = this.type == 'plain' ? '#fff' : colors[0];
          this.customBdColor = colors[0];
        }
      } else {
        this.customBgColor = '';
        this.customBdColor = '';
      }
    }
  }
};
</script>
<style lang="scss">
$baseColor: #2f58fe;
$hoverColor: #3d7dff;
$errorColor: #f21616;
$errorHoverColor: #f54646;

.bench-btn {
  display: inline-block;
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  &.el-button--primary {
    background-color: $baseColor;
    border-color: $baseColor;
    border-radius: 4px;
    &:focus,
    &:hover {
      color: #fff;
      background-color: $hoverColor;
      border-color: $hoverColor;
    }
    &.btn-danger {
      background-color: $errorColor;
      border-color: $errorColor;
      &:focus,
      &:hover {
        color: #fff;
        background-color: $errorHoverColor;
        border-color: $errorHoverColor;
      }
    }
    &.btn-plain {
      color: #343434;
      background-color: #fff;
      border-color: #d6d6d6;
      &:focus,
      &:hover {
        color: #343434;
        border-color: #343434;
      }
    }
    &.btn-pink {
      color: #fff;
      background-color: #ff8b91;
      border-color: #ff8b91;
      &:focus,
      &:hover {
        background-color: #ff656d;
        border-color: #ff656d;
      }
    }
    &.is-disabled {
      color: #ffffff;
      border-color: #d6d6d6;
      background-color: #d6d6d6;
      &:focus,
      &:hover {
        color: #ffffff;
        border-color: #d6d6d6;
        background-color: #d6d6d6;
      }
    }
  }
  &.el-button + &.el-button {
    margin-left: 11px;
  }
}
</style>
